import React from 'react'
import starIcon from '../../assets/images/icons/star-icon.png'
import coverage from '../../assets/images/services/n_m illustration.png'
import sketch from '../../assets/images/services/sketch_v2.png'
import sketchCoverage from '../../assets/images/services/sketch_coverage.png'
import sketchCoveragePartial from '../../assets/images/services/sketch_coverage_partial.png'
import Lightbox from 'react-image-lightbox'
import {Link} from 'gatsby'

const images = [
    (coverage),
    (sketch),
    (sketchCoverage),
    (sketchCoveragePartial),
];

const OurFeatures = () => {
    const [photoIndex, setPhotoIndex] = React.useState(0);
    const [isOpenImage, setIsOpenImage] = React.useState(false);

    return (
        <section className="services-area pt-100 pb-70 bg-f1f8fb">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src={starIcon} alt="feature" /> 
                        How does it Work
                    </span>

                    {/* <h2>We’re Here To Help</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                </div>

                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <div className="single-services-item-box">
                            {/* <div className="icon">
                                <img src={serviceIcon3} alt="feature" />
                            </div> */}
                            <div className="single-gallery-item">
                                <Link 
                                    to="#"
                                    onClick={e => {
                                        e.preventDefault(); 
                                        setIsOpenImage(true); 
                                        setPhotoIndex(0);}
                                    }
                                >
                                    <img src={coverage} alt="feature" />
                                </Link>
                            </div>
                            <h3>n:m Coverage</h3>
                            <p>There are many diffrent languages with different tools for coverage, we will bring it over an adapter to an Common API.
                                The Common API will make it easy to work with any Tool and Language and the Aapter are just some few lines of code or a common output format.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                        <div className="single-services-item-box">
                            {/* <div className="icon">
                                <img src={serviceIcon1} alt="feature" />
                            </div> */}
                            <div className="single-gallery-item">
                                <Link 
                                    to="#"
                                    onClick={e => {
                                        e.preventDefault(); 
                                        setIsOpenImage(true); 
                                        setPhotoIndex(1);}
                                    }
                                >
                                    <img src={sketch} alt="sketch" />
                                </Link>
                            </div>
                            <h3>feature Map Example</h3>
                            <p>The Features are Mapped in Code.
                                For Example the “Add” Feature is in line 4 and lines 13 to 18 and the “Subtract” Feature is in line 5 and lines 19 to 24 and the “Exit” Feature in line 7 , 25 and 26.
                            </p><p>
                                The Goal is it to make your Source easier to Navigate for you and others and in the progress make testing more effective.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                        <div className="single-services-item-box">
                            {/* <div className="icon">
                                <img src={serviceIcon2} alt="feature" />
                            </div> */}
                            <div className="single-gallery-item">
                                <Link 
                                    to="#"
                                    onClick={e => {
                                        e.preventDefault(); 
                                        setIsOpenImage(true); 
                                        setPhotoIndex(2);}
                                    }
                                >
                                    <img src={sketchCoverage} alt="sketchCoverage" />
                                </Link>
                            </div>
                            <h3>full Test Example</h3>
                            <p>This is the Output of Covarge.py and Coverage tool for python.
                                As you can see some parts are tested some arent, but which Features are being tested?
                            </p>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-sm-6">
                        <div className="single-services-item-box">
                            {/* <div className="icon">
                                <img src={serviceIcon3} alt="feature" />
                            </div> */}
                            <div className="single-gallery-item">
                                <Link 
                                    to="#"
                                    onClick={e => {
                                        e.preventDefault(); 
                                        setIsOpenImage(true); 
                                        setPhotoIndex(0);}
                                    }
                                >
                                    <img src={sketchCoveragePartial} alt="sketchCoveragePartial" />
                                </Link>
                            </div>
                            <h3>partial Test Example</h3>
                            <p>Here you can see that the “Subtract” Feature isn’t tested, 
                                so our tool will see this with the previos show Feature map and can give you a better idea of Covarge of your Code.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lightbox */}
            {isOpenImage && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setIsOpenImage(false)}
                        onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % images.length)
                        }
                    />
                )}
        </section>
    )
}

export default OurFeatures